import { mount } from 'svelte';
import Comments from '@components/Comments.svelte';

const Render = () => {
  const target = document.getElementById('comments-component') as HTMLElement;
  const { commentableType, commentableId } = target.dataset;

  if (!commentableType || !commentableId) {
    console.error('Commentable type or id not found');
    return;
  }

  const commentable = {
    type: commentableType,
    id: commentableId,
  };

  return mount(Comments, { target, props: { commentable } });
};

export default Render();
